// extracted by mini-css-extract-plugin
export default {"icon":"MultiValueRemove_icon__MnBTb"};